// @flow
import React from "react";
import PropTypes from "prop-types";
import { hotkeys, hotkey_display } from "react-keyboard-shortcuts";
import Icon from "../../common/Icon";
import I18n from "../../../i18n/I18n";
import styles from "./SearchInput.scss";

class SearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ""
    };
    this.inputChange = this.inputChange.bind(this);
  }
  inputChange(e) {
    this.setState({ searchVal: e.target.value });
    this.props.onSearch(e.target.value);
  }

  hot_keys = {
    "meta+f": {
      // combo from mousetrap
      priority: 1,
      handler: event => {
        event.preventDefault();
        this.nameInput.focus();
      }
    },
    "alt+f": {
      // combo from mousetrap
      priority: 1,
      handler: event => {
        event.preventDefault();
        this.nameInput.focus();
      }
    },
    "ctrl+f": {
      // combo from mousetrap
      priority: 1,
      handler: event => {
        event.preventDefault();
        this.nameInput.focus();
      }
    },
    esc: {
      // combo from mousetrap
      priority: 1,
      handler: event => {
        this.nameInput.blur();
      }
    }
  };

  render() {
    const searchLabel = this.props.searchLabel || "search.placeholder";
    const tooltip = hotkey_display("alt+n");
    return (
      <div className={styles.box}>
        <div className={styles.container}>
          <div className={styles.searchIcon}>
            <Icon name="search" />
          </div>
          {I18n.getComponent(
            formattedValue => (
              <input
                type="search"
                onChange={this.inputChange}
                className={styles.search}
                value={this.props.search}
                ref={input => {
                  this.nameInput = input;
                }}
                name="search"
                placeholder={formattedValue}
              />
            ),
            searchLabel
          )}
        </div>
      </div>
    );
  }
}

SearchInput.propTypes = {};

export default hotkeys(SearchInput);



// WEBPACK FOOTER //
// ./src/components/common/searchInput/SearchInput.js